import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Nav, NavDropdown } from "react-bootstrap";
import {
  UserAddOutlined,
  LogoutOutlined,
  ShoppingCartOutlined,
  ShoppingOutlined,
  ScheduleOutlined,
  GiftOutlined,
  AppstoreAddOutlined,
  UserOutlined,
  SearchOutlined,
  LoginOutlined,
} from "@ant-design/icons";
import "./NavbarHead.css";

import logo from "./img/logo-header.png";

const HeaderNew = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { user, cart } = useSelector((state) => ({ ...state }));
  const [keyword, setKeyword] = React.useState("");
  const [scrolled, setScrolled] = React.useState(false);
  const profileImage = user?.profileImage?.url || "";
  const topbarRef = React.useRef(null);

  React.useEffect(() => {
    const getScrollY = () =>
      window.scrollY ||
      document.documentElement.scrollTop ||
      document.body.scrollTop ||
      0;

    const handleScroll = () => {
      setScrolled(getScrollY() > 10);
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    document.addEventListener("scroll", handleScroll, { passive: true, capture: true });

    return () => {
      window.removeEventListener("scroll", handleScroll);
      document.removeEventListener("scroll", handleScroll, { capture: true });
    };
  }, []);

  // วัดความสูงจริงของ topbar แล้วส่งให้ ResponsiveNavbar ใช้คำนวณตำแหน่ง sticky
  React.useEffect(() => {
    const setHeightVar = () => {
      if (topbarRef.current) {
        const height = topbarRef.current.offsetHeight;
        document.documentElement.style.setProperty("--navbar-head-height", `${height}px`);
      }
    };

    setHeightVar();
    window.addEventListener("resize", setHeightVar);

    // รอ transition ของ search-wrap (ตอน scroll) จบก่อนวัดซ้ำ
    const timer = setTimeout(setHeightVar, 260);

    return () => {
      window.removeEventListener("resize", setHeightVar);
      clearTimeout(timer);
    };
  }, [scrolled]);

  const logout = () => {
    dispatch({ type: "LOGOUT", payload: null });
    navigate("/");
  };

  const handleSearch = (e) => {
    e.preventDefault();
    if (keyword.trim()) {
      navigate(`/shop?search=${encodeURIComponent(keyword.trim())}`);
    }
  };

  return (
    <div ref={topbarRef} className={`topbar ${scrolled ? "is-scrolled" : ""}`}>
      {/* โลโก้ */}
      <div className="logo-wrapper">
        <Link to="/">
          <img src={logo} alt="Logo" className="logo-image" />
        </Link>
      </div>

      {/* ค้นหา */}
      <form className="search-wrap" onSubmit={handleSearch}>
        <SearchOutlined className="search-icon" />
        <input
          type="text"
          className="search-input"
          placeholder="ค้นหาสินค้า"
          value={keyword}
          onChange={(e) => setKeyword(e.target.value)}
        />
      </form>

      {/* การ์ด / โปรไฟล์ */}
      <div className="top-actions">
        <Link to="/cart" className="icon-btn">
          <ShoppingCartOutlined />
          <span className="cart-label">ตะกร้าสินค้า</span>
          {cart.length > 0 && <span className="cart-badge">{cart.length}</span>}
        </Link>

        {user ? (
          <NavDropdown
            title={
              <>
                {profileImage ? (
                  <img src={profileImage} alt="profile" className="avatar-img" />
                ) : (
                  <div className="avatar">
                    <UserOutlined />
                  </div>
                )}
                {user.username}
              </>
            }
            id="basic-nav-dropdown"
            className="user-dropdown"
          >
            <NavDropdown.Item as={Link} to="/profile">
              <UserAddOutlined /> โปรไฟล์
            </NavDropdown.Item>

            {["staff", "admin"].includes(user?.role) && (
              <NavDropdown.Item as={Link} to="/admin/branch">
                ออกใบเสร็จ
              </NavDropdown.Item>
            )}

            {(user?.role === "staff" || user?.role === "admin" || user?.role === "accountant") && (
              <NavDropdown.Item as={Link} to="/admin/branch-list">
                รายการสั่งซื้อ
              </NavDropdown.Item>
            )}

            <NavDropdown.Item as={Link} to={user.role === "admin" ? "/admin/index" : "/user/index"}>
              <AppstoreAddOutlined /> Dashboard
            </NavDropdown.Item>
            <NavDropdown.Item as={Link} to="/shop">
              <ShoppingOutlined /> ร้านค้า
            </NavDropdown.Item>
            <NavDropdown.Item as={Link} to="/user/order-tracking">
              <ScheduleOutlined /> ติดตามคำสั่งซื้อ
            </NavDropdown.Item>
            <NavDropdown.Item as={Link} to="/promotion-user">
              <GiftOutlined /> โปรโมชั่น
            </NavDropdown.Item>
            <NavDropdown.Divider />
            <NavDropdown.Item onClick={logout}>
              <LogoutOutlined /> Logout
            </NavDropdown.Item>
          </NavDropdown>
        ) : (
          <>
            <Link to="/login" className="icon-btn">
              <LoginOutlined /> Login
            </Link>
            {/* <Link to="/register" className="icon-btn">
              <UserAddOutlined /> Register
            </Link> */}
          </>
        )}
      </div>
    </div>
  );
};

export default HeaderNew;